import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { libraryShape, subscriptionShape } from '@bibliocommons/bc-prop-types';
import {
  selectAvailabilityError,
  selectBibItemsForCurrentBib,
  selectSubscriptionsForCurrentBib
} from 'app/selectors/bibs/AvailabilitySelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import BibsActions from 'app/actions/BibsActions';
import AvailabilityDetails from './AvailabilityDetails';

export class AvailabilityDetailsContainer extends React.PureComponent {
  componentDidMount() {
    const { bibsActions, metadataId } = this.props;
    bibsActions.fetchAvailability(metadataId);
  }

  render() {
    return <AvailabilityDetails {...this.props} />;
  }
}

AvailabilityDetailsContainer.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  metadataId: PropTypes.string.isRequired,
  bibItems: ImmutablePropTypes.list.isRequired,
  subscriptions: ImmutablePropTypes.listOf(subscriptionShape).isRequired,
  availabilityError: PropTypes.string,
  currentLibrary: libraryShape.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => ({
  isFetching: state.getIn(['bibs', 'availability', 'isFetching'], false),
  availabilityError: selectAvailabilityError(state),
  bibItems: selectBibItemsForCurrentBib(state),
  subscriptions: selectSubscriptionsForCurrentBib(state),
  currentLibrary: selectCurrentLibrary(state)
});

const mapDispatchToProps = dispatch => ({
  bibsActions: bindActionCreators(BibsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityDetailsContainer);
